import { PremiumShippingTypeNames } from 'enums';

export const PREMIUM_SHIPPING_TYPE_NAMES = Object.values(
  PremiumShippingTypeNames
) as string[];

export const DEFAULT_SHIPPING_TYPE = PREMIUM_SHIPPING_TYPE_NAMES[0];
export const EARLIEST_DELIVERY_DATE = 'The earliest delivery date:';
